import { useQuery } from '@tanstack/react-query';
import { ChatRequests } from 'src/requests/chat';

export const useChatThreads = ({ channelId }: { channelId: string }) => {
  const queryKey = ['channelThreads', channelId];

  const {
    data: conversation,
    isFetching,
    isLoading: isLoadingSubchannels,
    refetch,
  } = useQuery({
    enabled: !!channelId,
    queryKey,
    queryFn: () => ChatRequests.getThreadsByChannelId(channelId),
    refetchOnWindowFocus: false,
  });

  return {
    conversation,
    isFetching,
    isLoadingSubchannels,
    refetch,
  };
};
